export default "__VITE_ASSET__DyjFz2mS__"